import bgtext from "../../../assetes/img/bgtext.svg";
import { Check } from "lucide-react"
export default function TargetAudience() {
    const audiences = [
        "هرکی یه ایده توپ داره ولی نمی‌دونه چجوری توکنشو بسازه",
        "کسایی که می‌خوان استارت‌آپ یا پروژه‌ی وب۳ خودشونو استارت بزنن",
        "شکارچی‌های میم‌کوین که می‌خوان خودشون سلطان بازار باشن",
        "اونایی که دنبال درآمد دلاری از پروژه‌های کریپتویی هستن و می‌خوان خودشونو بکشن بالا",
        "هرکی که می‌خواد یه بار برای همیشه ساخت توکن، مارکتینگ و مدیریت لیکویدیتی رو یاد بگیره و مستقل بشه",
      ]
    
      return (
        <div className="flex justify-center items-center min-h-screen p-4 w-[500px] max-[600px]:w-[330px] m-auto">
            <div className="w-[500px] max-[600px]:w-[340px] max-[400px]:hidden h-96  bg-[#7E42FF] absolute rounded-[2rem] mt-[150px] max-[600px]:mt-[130px]"></div>
          <div className="relative w-[400px] max-w-2xl bg-gradient-to-b from-[#4400D8] to-[#7E42FF] rounded-[2rem] p-8 text-white text-right overflow-hidden shadow-lg">
            {/* تزئین بک‌گراند */}
           
            <img className="absolute bottom-0 left-0" src={bgtext}/>
           
    
            <h2 className="text-2xl text-center font-black mb-8 max-[600px]:mb-5  max-[600px]:text-xl">
              این دوره مناسب چه کساییه؟
            </h2>
            <div className="w-full h-px bg-gradient-to-r from-transparent via-white to-transparent my-5" />
            <div className="space-y-6 z-10 relative text-right">
              {audiences.map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <p className="leading-relaxed max-[600px]:text-sm">{item}</p>
                  <div className="bg-white text-purple-700 p-1 rounded-full mt-1">
                    <Check className="w-4 h-4" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )
    }